export const INVALID_BOOKING_MOBILE_REQUEST = 'invalidBookingMobileRequest';
export const BOOKING_REQUEST_MOBILE_SUBMIT = 'bookingRequestMobileSubmit';
export const RENDER_MOBILE_SUBMIT_BUTTON = 'renderBookingSubmitButton';
export const DATE_FROM_DEFINED = 'dateFromDefined';
export const DATE_FROM_NOT_DEFINED = 'dateFromNotDefined';
